import { createFileRoute } from '@tanstack/react-router';
import { ChoiceTypeManagement } from '../../../features/choices/choiceTypeManagement';
import { choicesReadGuard } from '@bmwe/ui';

export const Route = createFileRoute('/auswahlfelder/status/')({
  component: () => (
    <ChoiceTypeManagement
      choiceTypeKey="Status"
      returnRoute="/auswahlfelder/status"
    />
  ),
  beforeLoad: choicesReadGuard,
});

export const StatusRoute = Route;
